import * as React from 'react';
import { IconProps } from '../types';

const IcCategory = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M2.98 2.931v6.45h6.45v-6.45H2.98Zm-.396-1.186a.79.79 0 0 0-.79.79v7.242c0 .437.354.79.79.79h7.242a.79.79 0 0 0 .79-.79V2.536a.79.79 0 0 0-.79-.791H2.584ZM14.966 2.931v6.45h6.45v-6.45h-6.45Zm-.395-1.186a.79.79 0 0 0-.791.79v7.242c0 .437.354.79.79.79h7.242a.79.79 0 0 0 .79-.79V2.536a.79.79 0 0 0-.79-.791h-7.241ZM2.98 14.517v6.45h6.45v-6.45H2.98Zm-.396-1.186a.79.79 0 0 0-.79.79v7.242c0 .436.354.79.79.79h7.242a.79.79 0 0 0 .79-.79V14.12a.79.79 0 0 0-.79-.79H2.584Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M17.325 14.545a1 1 0 0 1 1.732 0l3.232 5.597a1 1 0 0 1-.866 1.5H14.96a1 1 0 0 1-.866-1.5l3.231-5.597Z"
    />
  </svg>
);

export default IcCategory;
